export default __webpack_public_path__ + "static/media/WorkoutTracker_Landing.917dcee4.PNG";